module.exports = __webpack_public_path__ + "img/linkedin.f754ec6f.svg";